export const StarSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.7831 14.6091C13.0455 15.3172 10.0997 18.2631 9.39162 22.0007C8.68355 18.2631 5.73778 15.3173 2.00024 14.6091C5.73778 13.9009 8.68356 10.9551 9.39163 7.21751C10.0997 10.9551 13.0455 13.9009 16.7831 14.6091Z"
        fill="white"
      />
      <path
        d="M21.9999 5.47823C20.2413 5.81167 18.8553 7.19781 18.5222 8.95644C18.189 7.19781 16.803 5.81168 15.0445 5.47823C16.803 5.14478 18.189 3.75864 18.5221 2C18.8553 3.75864 20.2413 5.14478 21.9999 5.47823Z"
        fill="white"
      />
      <path
        d="M16.7831 14.6091C13.0455 15.3172 10.0997 18.2631 9.39162 22.0007C8.68355 18.2631 5.73778 15.3173 2.00024 14.6091C5.73778 13.9009 8.68356 10.9551 9.39163 7.21751C10.0997 10.9551 13.0455 13.9009 16.7831 14.6091Z"
        stroke="#F9F9F9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9999 5.47823C20.2413 5.81167 18.8553 7.19781 18.5222 8.95644C18.189 7.19781 16.803 5.81168 15.0445 5.47823C16.803 5.14478 18.189 3.75864 18.5221 2C18.8553 3.75864 20.2413 5.14478 21.9999 5.47823Z"
        stroke="#F9F9F9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
